import { FormlyField } from '@ngx-formly/core';

export abstract class DynButtonInterface {
    abstract onClick(field: FormlyField, $event: any, id?: string);
}
